import { axios } from 'Core'
import { debug } from 'Utils/DebugHelper'

export default class authApis {
  static async checkAuth() {
    const apiKey = debug.getApiToken()
    const requestObject = {
      method: 'GET',
      url: '/whoami'
    }
    /** Add jwt if developing off tunnel */
    if (apiKey) {
      requestObject.headers = { Authorization: `Bearer ${apiKey}` }
    }
    const response = await axios(requestObject)
    return response
  }
}
